import { render, staticRenderFns } from "./Recorder.vue?vue&type=template&id=2ba91513&scoped=true&"
import script from "./Recorder.vue?vue&type=script&lang=js&"
export * from "./Recorder.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pc/recorder.css?vue&type=style&index=0&id=2ba91513&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba91513",
  null
  
)

export default component.exports